import { render, staticRenderFns } from "./connect-header.vue?vue&type=template&id=3645969a&scoped=true&"
import script from "./connect-header.vue?vue&type=script&lang=js&"
export * from "./connect-header.vue?vue&type=script&lang=js&"
import style0 from "./connect-header.vue?vue&type=style&index=0&id=3645969a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645969a",
  null
  
)

export default component.exports